
import { MapLocation } from '@/types/location';
import { duelArenaGameCenters } from './duelArenaGameCenters';
import { ressGamingCenters } from './ressGamingCenters';
import { houseOfNetworkGameCenters } from './houseOfNetworkGameCenters';
import { poolChallengeCafes } from './poolChallengeCafes';
import { gammaGameCenters } from './gammaGameCenters';
import { asparEntertainmentCenters } from './asparEntertainmentCenters';
import { legendsGamingCenters } from './legendsGamingCenters';
import { starZoneBilliardsCenters } from './starZoneBilliardsCenters';
import { rqArenaCenters } from './rqArenaCenters';
import { yellowLineGamingCenters } from './yellowLineGamingCenters';
import { boostGamingCenters } from './boostGamingCenters';
import { celebrityCenters } from './celebrityCenters';
import { blackBallCenters } from './blackBallCenters';
import { cupardoBilliardsCenters } from './cupardoBilliardsCenters';
import { superTouchCenters } from './superTouchCenters';
import { qeuzGamingCenters } from './qeuzGamingCenters';
import { gameEveningCenters } from './gameEveningCenters';
import { snookerCenters } from './snookerCenters';

// Alan Game Center Locations - Combined from all game center location files
export const alanGameCenterLocations: MapLocation[] = [
  ...duelArenaGameCenters,
  ...ressGamingCenters,
  ...houseOfNetworkGameCenters,
  ...poolChallengeCafes,
  ...gammaGameCenters,
  ...asparEntertainmentCenters,
  ...legendsGamingCenters,
  ...starZoneBilliardsCenters,
  ...rqArenaCenters,
  ...yellowLineGamingCenters,
  ...boostGamingCenters,
  ...celebrityCenters,
  ...blackBallCenters,
  ...cupardoBilliardsCenters,
  ...superTouchCenters,
  ...qeuzGamingCenters,
  ...gameEveningCenters,
  ...snookerCenters
];
